<template>
  <v-container>
    <PageHeader :title="name" />
    <Subheader title="Map Layer List" no-search>
      <v-btn dark color="success" v-if="newMapServiceConfigs.length != 0" @click="showAddDialog=true">
        <v-icon class="mr-1">add</v-icon>{{ $t('Button.Add') }}
      </v-btn>
      <v-btn dark color="success" v-if="newMapServiceConfigs.length == 0" @click="showAddConfirmDialog = true">
        <v-icon class="mr-1">add</v-icon>{{ $t('Button.GenerateDefaultLayers') }}
      </v-btn>
    </Subheader>
    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="newMapServiceConfigs">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.LayerName }}</td>
            <td class="text-xs-left">{{ props.item.DisplayName }}</td>
            <td class="text-xs-center">
              <v-icon v-show="props.item.ShowOnLoad" color="success">check</v-icon>
              <v-icon v-show="!props.item.ShowOnLoad" color="delete">close</v-icon>
            </td>
            <td class="text-xs-left">{{ props.item.Ordinal }}</td>
            <td class="text-xs-right">
              <v-btn dark color="warning" @click="gotoEdit(props.item)">
                <v-icon class="mr-1">edit</v-icon>
                {{ $t('Button.Edit') }}
              </v-btn>
              <v-btn dark color="error" @click="showDeleteMapLayer(props.item)" :disabled="!deleteable(props.item.LayerName)">
                <v-icon class="mr-1">delete_forever</v-icon>
                {{ $t('Button.Delete') }}
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showAddConfirmDialog" persistent max-width="400px">
      <v-card>
        <v-toolbar dense dark color="secondary">
          <v-toolbar-title>Generate Default Layers</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showAddConfirmDialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>Tenant does not have any map layers. Do you want to generate the default basemap and satelite image
          map layers?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="addDefaultLayer()">
            <v-icon>done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
          <v-btn outline color="secondary" @click="showAddConfirmDialog = false">{{ $t('Button.Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Add A New Map Layer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 pa-3>
              <v-text-field label="Name" v-model="addMapLayerData.LayerName"></v-text-field>
              <v-text-field label="DisplayName" v-model="addMapLayerData.DisplayName"></v-text-field>
              <v-switch v-model="addMapLayerData.ShowOnLoad" :label="`ShowLoading : ${addMapLayerData.ShowOnLoad.toString()}`"></v-switch>
              <v-select v-model="addMapLayerData.Ordinal" :items="getOrdinal" label="Ordinal"></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="addNewMapLayer()">
            <v-icon>done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
          <v-btn outline color="secondary" @click="close()">{{ $t('Button.Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Delete Map Layer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="deleteDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>Are you sure , delete this map layer ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="error" @click="agreeDelete()">
            <v-icon class="mr-1">delete_forever</v-icon>delete
          </v-btn>
          <v-btn outline color="secondary" @click="deleteDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import SnackBarUtil from '../mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'
  const app = createNamespacedHelpers('app')
  const admin = createNamespacedHelpers('admin')

  export default {
    components: {
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        headers: [
          { align: 'left', text: 'Name', value: 'Name' },
          { align: 'left', text: 'DisplayName', value: 'DisplayName' },
          { align: 'center', text: 'ShowLoading', value: 'ShowLoading' },
          { align: 'left', text: 'Ordinal', value: 'Ordinal' },
          { sortable: false, text: '', value: '' },
        ],
        mapLayers: ['cad', 'dpl_watershed'],
        showAddConfirmDialog: false,
        showAddDialog: false,
        deleteDialog: false,
        addMapLayerData: {
          Id: null,
          LayerName: '',
          DisplayName: '',
          ShowOnLoad: false,
          Ordinal: null,
          RoleMapId: null,
        },
        deleteId: null,
      }
    },
    mounted() {
      this.fetchMapServiceConfig()
    },
    computed: {
      ...app.mapGetters(['newMapServiceConfigs']),
      ...admin.mapGetters(['roleList']),
      getOrdinal() {
        let arr = []
        let length = this.newMapServiceConfigs.length
        for (var i = 1; i <= length + 1; i++) {
          arr.push(i)
        }
        return arr
      },
      getRoleMapId() {
        let role = this.roleList.find(x => x.RoleName == this.name)
        return role.Id
      },
      selectMapLayers() {
        var arr = []
        this.mapLayers.forEach(element => {
          var match = this.newMapServiceConfigs.find(x => x.LayerName == element)
          if (match == null) {
            arr.push(element)
          }
        })
        return arr
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {},
    methods: {
      ...app.mapActions(['getNewMapServiceConfig', 'addMapLayer', 'deleteMapLayer', 'AddDefaultMapLayers']),
      async fetchMapServiceConfig() {
        await this.getNewMapServiceConfig(this.name)
      },
      gotoEdit(data) {
        this.$router.push({
          name: 'mapLayerDetail',
          params: {
            name: data.LayerName,
          },
        })
      },
      showDeleteMapLayer(data) {
        this.deleteDialog = true
        this.deleteId = data.Id
      },
      deleteable(data) {
        var arr = ['topo', 'station', 'sat', 'sampleSat']
        var match = arr.find(x => x == data)
        if (match == null) {
          return true
        }
        return false
      },
      agreeDelete() {
        let options = {
          data: {
            Id: this.deleteId,
          },
          successCb: () => {
            this.snackMessage = 'Delete success.'
            this.snackColor = 'success'
            this.snackbar = true
            this.deleteDialog = false
          },
          failedCb: (err) => {
            this.$store.dispatch('app/setErrorDialog', {
              data: err.response.data,
              title: err.message,
              show: true,
            })
          },
        }
        this.deleteMapLayer(options)
      },
      addNewMapLayer() {
        this.addMapLayerData.RoleMapId = this.getRoleMapId
        if (this.addMapLayerData.LayerName && this.addMapLayerData.DisplayName && this.addMapLayerData.Ordinal) {
          let options = {
            data: {
              Id: null,
              LayerName: this.addMapLayerData.LayerName,
              DisplayName: this.addMapLayerData.DisplayName,
              ShowOnLoad: this.addMapLayerData.ShowOnLoad,
              Ordinal: this.addMapLayerData.Ordinal,
              RoleMapId: this.addMapLayerData.RoleMapId,
            },
            successCb: () => {
              this.snackMessage = 'Save success.'
              this.snackColor = 'success'
              this.snackbar = true
              this.close()
            },
            failedCb: (err) => {
              this.$store.dispatch('app/setErrorDialog', {
                data: err.response.data,
                title: err.message,
                show: true,
              })
            },
          }
          this.addMapLayer(options)
        } else {
          this.snackMessage = 'Can not be null, please look over.'
          this.snackColor = 'error'
          this.snackbar = true
        }
      },
      addDefaultLayer() {
        let options = {
          data: this.getRoleMapId,
          successCb: () => {
            this.snackMessage = 'Save success.'
            this.snackColor = 'success'
            this.snackbar = true
            this.showAddConfirmDialog = false
          },
          failedCb: (err) => {
            this.$store.dispatch('app/setErrorDialog', {
              data: err.response.data,
              title: err.message,
              show: true,
            })
          },
        }
        this.AddDefaultMapLayers(options)
      },
      close() {
        this.showAddDialog = false
        this.addMapLayerData = {
          Id: null,
          LayerName: '',
          DisplayName: '',
          ShowOnLoad: false,
          Ordinal: null,
          RoleMapId: null,
        }
      },
    },
  }
</script>

<style scoped lang="stylus"></style>